/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CaseloadModel } from '../models/caseload-model';
import { ClientCaseModel } from '../models/client-case-model';
import { MeetingAttendeeModel } from '../models/meeting-attendee-model';
import { MeetingModel } from '../models/meeting-model';
import { MeetingOccurrenceModel } from '../models/meeting-occurrence-model';
import { MeetingSubjectTypes } from '../models/meeting-subject-types';
import { ProcessResponse } from '../models/process-response';
import { SiteRoomModel } from '../models/site-room-model';

@Injectable({
  providedIn: 'root',
})
export class SchedulingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  static readonly ApiSchedulingParentMeetingKeyGetPath = '/api/Scheduling/{parentMeetingKey}';

  apiSchedulingParentMeetingKeyGet$Json$Response(params: {
    parentMeetingKey: number;
  }): Observable<StrictHttpResponse<MeetingModel>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingKeyGetPath, 'get');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<MeetingModel>)
    );
  }

  apiSchedulingParentMeetingKeyGet$Json(params: {
    parentMeetingKey: number;
  }): Observable<MeetingModel> {
    return this.apiSchedulingParentMeetingKeyGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MeetingModel>) => r.body as MeetingModel)
    );
  }

  static readonly ApiSchedulingParentMeetingKeyDeletePath = '/api/Scheduling/{parentMeetingKey}';

  apiSchedulingParentMeetingKeyDelete$Json$Response(params: {
    parentMeetingKey: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingKeyDeletePath, 'delete');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingParentMeetingKeyDelete$Json(params: {
    parentMeetingKey: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingParentMeetingKeyDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingParentSiteKeyRoomsGetPath = '/api/Scheduling/{parentSiteKey}/rooms';

  apiSchedulingParentSiteKeyRoomsGet$Json$Response(params: {
    parentSiteKey: number;
  }): Observable<StrictHttpResponse<Array<SiteRoomModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentSiteKeyRoomsGetPath, 'get');
    if (params) {
      rb.path('parentSiteKey', params.parentSiteKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<SiteRoomModel>>)
    );
  }

  apiSchedulingParentSiteKeyRoomsGet$Json(params: {
    parentSiteKey: number;
  }): Observable<Array<SiteRoomModel>> {
    return this.apiSchedulingParentSiteKeyRoomsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SiteRoomModel>>) => r.body as Array<SiteRoomModel>)
    );
  }

  static readonly ApiSchedulingAttendeeParentMeetingAttendeeKeyDeletePath = '/api/Scheduling/attendee/{parentMeetingAttendeeKey}';

  apiSchedulingAttendeeParentMeetingAttendeeKeyDelete$Json$Response(params: {
    parentMeetingAttendeeKey: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingAttendeeParentMeetingAttendeeKeyDeletePath, 'delete');
    if (params) {
      rb.path('parentMeetingAttendeeKey', params.parentMeetingAttendeeKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingAttendeeParentMeetingAttendeeKeyDelete$Json(params: {
    parentMeetingAttendeeKey: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingAttendeeParentMeetingAttendeeKeyDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingAttendeeDeletePath = '/api/Scheduling/attendee';

  apiSchedulingAttendeeDelete$Json$Response(params?: {
    applyToSeries?: null | boolean;
    body?: null | Array<number>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingAttendeeDeletePath, 'delete');
    if (params) {
      rb.query('applyToSeries', params.applyToSeries, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingAttendeeDelete$Json(params?: {
    applyToSeries?: null | boolean;
    body?: null | Array<number>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingAttendeeDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingMeetingOccurrenceParentMeetingOccurrenceKeyGetPath = '/api/Scheduling/meetingOccurrence/{parentMeetingOccurrenceKey}';

  apiSchedulingMeetingOccurrenceParentMeetingOccurrenceKeyGet$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
  }): Observable<StrictHttpResponse<MeetingOccurrenceModel>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingMeetingOccurrenceParentMeetingOccurrenceKeyGetPath, 'get');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<MeetingOccurrenceModel>)
    );
  }

  apiSchedulingMeetingOccurrenceParentMeetingOccurrenceKeyGet$Json(params: {
    parentMeetingOccurrenceKey: number;
  }): Observable<MeetingOccurrenceModel> {
    return this.apiSchedulingMeetingOccurrenceParentMeetingOccurrenceKeyGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MeetingOccurrenceModel>) => r.body as MeetingOccurrenceModel)
    );
  }

  static readonly ApiSchedulingEmployeeAppointmentsGetPath = '/api/Scheduling/employeeFutureAppointments/{employeeKey}';

  apiSchedulingEmployeeAppointmentsGet$Json$Response(params?: {
    employeeKey?: null | number;
  }): Observable<StrictHttpResponse<Array<MeetingModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingEmployeeAppointmentsGetPath, 'get');
    if (params) {
      rb.path('employeeKey', params.employeeKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<MeetingModel>>)
    );
  }

  apiSchedulingEmployeeAppointmentsGet$Json(params?: {
    employeeKey?: null | number;
  }): Observable<Array<MeetingModel>> {
    return this.apiSchedulingEmployeeAppointmentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MeetingModel>>) => r.body as Array<MeetingModel>)
    );
  }

  static readonly ApiSchedulingMeetingOccurrenceGetPath = '/api/Scheduling/meetingOccurrence';

  apiSchedulingMeetingOccurrenceGet$Json$Response(params?: {
    parentSiteKey?: null | Array<number>;
    parentEmployeeKey?: null | Array<number>;
    meetingCategoryType?: null | Array<string>;
    meetingSubjectType?: null | Array<string>;
    fromDate?: null | string;
    toDate?: null | string;
    parentOrganizationalUnitKey?: null | Array<number>;
  }): Observable<StrictHttpResponse<Array<MeetingOccurrenceModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingMeetingOccurrenceGetPath, 'get');
    if (params) {
      const employeeArray = encodeURIComponent(JSON.stringify(params.parentEmployeeKey));
      rb.query('parentSiteKey', params.parentSiteKey, {});
      rb.query('parentEmployeeKey', employeeArray, {});
      rb.query('meetingCategoryType', params.meetingCategoryType, {});
      rb.query('meetingSubjectType', params.meetingSubjectType, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('parentOrganizationalUnitKey', params.parentOrganizationalUnitKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<MeetingOccurrenceModel>>)
    );
  }

  apiSchedulingMeetingOccurrenceGet$Json(params?: {
    parentSiteKey?: null | Array<number>;
    parentEmployeeKey?: null | Array<number>;
    meetingCategoryType?: null | Array<string>;
    meetingSubjectType?: null | Array<string>;
    fromDate?: null | string;
    toDate?: null | string;
    parentOrganizationalUnitKey?: null | Array<number>;
  }): Observable<Array<MeetingOccurrenceModel>> {
    return this.apiSchedulingMeetingOccurrenceGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MeetingOccurrenceModel>>) => r.body as Array<MeetingOccurrenceModel>)
    );
  }

  static readonly ApiSchedulingEmployeeParentEmployeeKeyGetPath = '/api/Scheduling/employee/{parentEmployeeKey}';

  apiSchedulingEmployeeParentEmployeeKeyGet$Json$Response(params: {
    parentEmployeeKey: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingStatusCode?: null | string;
  }): Observable<StrictHttpResponse<Array<MeetingOccurrenceModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingEmployeeParentEmployeeKeyGetPath, 'get');
    if (params) {
      rb.path('parentEmployeeKey', params.parentEmployeeKey, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('meetingStatusCode', params.meetingStatusCode, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<MeetingOccurrenceModel>>)
    );
  }

  apiSchedulingEmployeeParentEmployeeKeyGet$Json(params: {
    parentEmployeeKey: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingStatusCode?: null | string;
  }): Observable<Array<MeetingOccurrenceModel>> {
    return this.apiSchedulingEmployeeParentEmployeeKeyGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MeetingOccurrenceModel>>) => r.body as Array<MeetingOccurrenceModel>)
    );
  }

  static readonly ApiSchedulingMeetingOccurrencePostPath = '/api/Scheduling/meetingOccurrence';

  apiSchedulingMeetingOccurrencePost$Json$Response(params?: {
    body?: MeetingOccurrenceModel;
  }): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingMeetingOccurrencePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<string>)
    );
  }

  apiSchedulingMeetingOccurrencePost$Json(params?: {
    body?: MeetingOccurrenceModel;
  }): Observable<string> {
    return this.apiSchedulingMeetingOccurrencePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  static readonly ApiSchedulingPostPath = '/api/Scheduling';

  apiSchedulingPost$Json$Response(params?: {
    body?: MeetingModel;
  }): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<string>)
    );
  }

  apiSchedulingPost$Json(params?: {
    body?: MeetingModel;
  }): Observable<string> {
    return this.apiSchedulingPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  static readonly ApiSchedulingGroupMeetingOccurrencePostPath = '/api/Scheduling/groupMeetingOccurrence';

  apiSchedulingGroupMeetingOccurrencePost$Json$Response(params?: {
    body?: MeetingOccurrenceModel;
  }): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingGroupMeetingOccurrencePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<string>)
    );
  }

  apiSchedulingGroupMeetingOccurrencePost$Json(params?: {
    body?: MeetingOccurrenceModel;
  }): Observable<string> {
    return this.apiSchedulingGroupMeetingOccurrencePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  static readonly ApiSchedulingGroupMeetingSeriesPostPath = '/api/Scheduling/groupMeetingSeries';

  apiSchedulingGroupMeetingSeriesPost$Json$Response(params?: {
    body?: MeetingModel;
  }): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingGroupMeetingSeriesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<string>)
    );
  }

  apiSchedulingGroupMeetingSeriesPost$Json(params?: {
    body?: MeetingModel;
  }): Observable<string> {
    return this.apiSchedulingGroupMeetingSeriesPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  static readonly ApiSchedulingGroupMeetingSeriesParentMeetingKeyClientsPostPath = '/api/Scheduling/groupMeetingSeries/{parentMeetingKey}/clients';

  apiSchedulingGroupMeetingSeriesParentMeetingKeyClientsPost$Json$Response(params: {
    parentMeetingKey: number;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingGroupMeetingSeriesParentMeetingKeyClientsPostPath, 'post');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingGroupMeetingSeriesParentMeetingKeyClientsPost$Json(params: {
    parentMeetingKey: number;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingGroupMeetingSeriesParentMeetingKeyClientsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeDeletePath = '/api/Scheduling/groupMeetingSeries/{parentMeetingKey}/attendee';

  apiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeDelete$Json$Response(params: {
    parentMeetingKey: number;
    body?: null | Array<number>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeDeletePath, 'delete');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeDelete$Json(params: {
    parentMeetingKey: number;
    body?: null | Array<number>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeClientsPostPath = '/api/Scheduling/groupMeetingSeries/{parentMeetingKey}/attendee/clients';

  apiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeClientsPost$Json$Response(params: {
    parentMeetingKey: number;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeClientsPostPath, 'post');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeClientsPost$Json(params: {
    parentMeetingKey: number;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingGroupMeetingSeriesParentMeetingKeyAttendeeClientsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingIntakeMeetingParentMeetingOccurrenceKeyPostPath = '/api/Scheduling/intakeMeeting/{parentMeetingOccurrenceKey}';

  apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyPost$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
    parentInquiryKey?: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingIntakeMeetingParentMeetingOccurrenceKeyPostPath, 'post');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
      rb.query('parentInquiryKey', params.parentInquiryKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyPost$Json(params: {
    parentMeetingOccurrenceKey: number;
    parentInquiryKey?: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingIntakeMeetingParentMeetingOccurrenceKeyExistingClientParentClientKeyPostPath = '/api/Scheduling/intakeMeeting/{parentMeetingOccurrenceKey}/existingClient/{parentClientKey}';

  apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyExistingClientParentClientKeyPost$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
    parentInquiryKey?: number;
    parentClientKey: number;
  }): Observable<StrictHttpResponse<ClientCaseModel>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingIntakeMeetingParentMeetingOccurrenceKeyExistingClientParentClientKeyPostPath, 'post');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
      rb.path('parentClientKey', params.parentClientKey, {});
      rb.query('parentInquiryKey', params.parentInquiryKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ClientCaseModel>)
    );
  }

  apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyExistingClientParentClientKeyPost$Json(params: {
    parentMeetingOccurrenceKey: number;
    parentInquiryKey?: number;
    parentClientKey: number;
  }): Observable<ClientCaseModel> {
    return this.apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyExistingClientParentClientKeyPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClientCaseModel>) => r.body as ClientCaseModel)
    );
  }

  static readonly ApiSchedulingParentMeetingOccurrenceKeyLockPostPath = '/api/Scheduling/{parentMeetingOccurrenceKey}/lock';

  apiSchedulingParentMeetingOccurrenceKeyLockPost$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingOccurrenceKeyLockPostPath, 'post');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingParentMeetingOccurrenceKeyLockPost$Json(params: {
    parentMeetingOccurrenceKey: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingParentMeetingOccurrenceKeyLockPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingParentMeetingOccurrenceKeyUnlockPostPath = '/api/Scheduling/{parentMeetingOccurrenceKey}/unlock';

  apiSchedulingParentMeetingOccurrenceKeyUnlockPost$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingOccurrenceKeyUnlockPostPath, 'post');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingParentMeetingOccurrenceKeyUnlockPost$Json(params: {
    parentMeetingOccurrenceKey: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingParentMeetingOccurrenceKeyUnlockPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingParentMeetingKeyEmployeePostPath = '/api/Scheduling/{parentMeetingKey}/employee';

  apiSchedulingParentMeetingKeyEmployeePost$Json$Response(params: {
    parentMeetingKey: number;
    parentEmployeeKey?: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingKeyEmployeePostPath, 'post');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
      rb.query('parentEmployeeKey', params.parentEmployeeKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingParentMeetingKeyEmployeePost$Json(params: {
    parentMeetingKey: number;
    parentEmployeeKey?: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingParentMeetingKeyEmployeePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingParentMeetingKeyClientPostPath = '/api/Scheduling/{parentMeetingKey}/client';

  apiSchedulingParentMeetingKeyClientPost$Json$Response(params: {
    parentMeetingKey: number;
    parentClientKey?: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingKeyClientPostPath, 'post');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
      rb.query('parentClientKey', params.parentClientKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingParentMeetingKeyClientPost$Json(params: {
    parentMeetingKey: number;
    parentClientKey?: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingParentMeetingKeyClientPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingParentMeetingKeyClientsPostPath = '/api/Scheduling/{parentMeetingKey}/clients';

  apiSchedulingParentMeetingKeyClientsPost$Json$Response(params: {
    parentMeetingKey: number;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingParentMeetingKeyClientsPostPath, 'post');
    if (params) {
      rb.path('parentMeetingKey', params.parentMeetingKey, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingParentMeetingKeyClientsPost$Json(params: {
    parentMeetingKey: number;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingParentMeetingKeyClientsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingMeetingOccurrencesParentMeetingOccurrenceKeyClientsPostPath = '/api/Scheduling/meetingOccurrences/{parentMeetingOccurrenceKey}/clients';

  apiSchedulingMeetingOccurrencesParentMeetingOccurrenceKeyClientsPost$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
    applyToSeries?: null | boolean;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingMeetingOccurrencesParentMeetingOccurrenceKeyClientsPostPath, 'post');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
      rb.query('applyToSeries', params.applyToSeries, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingMeetingOccurrencesParentMeetingOccurrenceKeyClientsPost$Json(params: {
    parentMeetingOccurrenceKey: number;
    applyToSeries?: null | boolean;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingMeetingOccurrencesParentMeetingOccurrenceKeyClientsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingAttendeeClientPostPath = '/api/Scheduling/attendee/client';

  apiSchedulingAttendeeClientPost$Json$Response(params?: {
    body?: MeetingAttendeeModel;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingAttendeeClientPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingAttendeeClientPost$Json(params?: {
    body?: MeetingAttendeeModel;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingAttendeeClientPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingAttendeeClientsPostPath = '/api/Scheduling/attendee/clients';

  apiSchedulingAttendeeClientsPost$Json$Response(params?: {
    applyToSeries?: null | boolean;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingAttendeeClientsPostPath, 'post');
    if (params) {
      rb.query('applyToSeries', params.applyToSeries, {});
      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingAttendeeClientsPost$Json(params?: {
    applyToSeries?: null | boolean;
    body?: Array<MeetingAttendeeModel>;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingAttendeeClientsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingSiteParentSiteKeyAvailableMeetingsGetPath = '/api/Scheduling/site/{parentSiteKey}/availableMeetings';

  apiSchedulingSiteParentSiteKeyAvailableMeetingsGet$Json$Response(params: {
    parentSiteKey: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingSubjectType?: MeetingSubjectTypes;
  }): Observable<StrictHttpResponse<Array<MeetingOccurrenceModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingSiteParentSiteKeyAvailableMeetingsGetPath, 'get');
    if (params) {
      rb.path('parentSiteKey', params.parentSiteKey, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('meetingSubjectType', params.meetingSubjectType, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<MeetingOccurrenceModel>>)
    );
  }

  apiSchedulingSiteParentSiteKeyAvailableMeetingsGet$Json(params: {
    parentSiteKey: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingSubjectType?: MeetingSubjectTypes;
  }): Observable<Array<MeetingOccurrenceModel>> {
    return this.apiSchedulingSiteParentSiteKeyAvailableMeetingsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MeetingOccurrenceModel>>) => r.body as Array<MeetingOccurrenceModel>)
    );
  }

  static readonly ApiSchedulingCaseParentCaseKeyGetPath = '/api/Scheduling/case/{parentCaseKey}';

  apiSchedulingCaseParentCaseKeyGet$Json$Response(params: {
    parentCaseKey: number;
  }): Observable<StrictHttpResponse<Array<MeetingOccurrenceModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingCaseParentCaseKeyGetPath, 'get');
    if (params) {
      rb.path('parentCaseKey', params.parentCaseKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<MeetingOccurrenceModel>>)
    );
  }

  apiSchedulingCaseParentCaseKeyGet$Json(params: {
    parentCaseKey: number;
  }): Observable<Array<MeetingOccurrenceModel>> {
    return this.apiSchedulingCaseParentCaseKeyGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MeetingOccurrenceModel>>) => r.body as Array<MeetingOccurrenceModel>)
    );
  }

  static readonly ApiSchedulingIntakeMeetingParentMeetingOccurrenceKeyParentClientKeyPostPath = '/api/Scheduling/intakeMeeting/{parentMeetingOccurrenceKey}/{parentClientKey}';

  apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyParentClientKeyPost$Json$Response(params: {
    parentMeetingOccurrenceKey: number;
    parentClientKey: number;
  }): Observable<StrictHttpResponse<ProcessResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingIntakeMeetingParentMeetingOccurrenceKeyParentClientKeyPostPath, 'post');
    if (params) {
      rb.path('parentMeetingOccurrenceKey', params.parentMeetingOccurrenceKey, {});
      rb.path('parentClientKey', params.parentClientKey, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<ProcessResponse>)
    );
  }

  apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyParentClientKeyPost$Json(params: {
    parentMeetingOccurrenceKey: number;
    parentClientKey: number;
  }): Observable<ProcessResponse> {
    return this.apiSchedulingIntakeMeetingParentMeetingOccurrenceKeyParentClientKeyPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  static readonly ApiSchedulingSiteParentSiteKeyMeetingCountGetPath = '/api/Scheduling/site/{parentSiteKey}/{meetingCount}';

  apiSchedulingSiteParentSiteKeyMeetingCountGet$Json$Response(params: {
    parentSiteKey: number;
    meetingCount: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingSubjectType?: MeetingSubjectTypes;
  }): Observable<StrictHttpResponse<Array<MeetingOccurrenceModel>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingSiteParentSiteKeyMeetingCountGetPath, 'get');
    if (params) {
      rb.path('parentSiteKey', params.parentSiteKey, {});
      rb.path('meetingCount', params.meetingCount, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('meetingSubjectType', params.meetingSubjectType, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<MeetingOccurrenceModel>>)
    );
  }

  apiSchedulingSiteParentSiteKeyMeetingCountGet$Json(params: {
    parentSiteKey: number;
    meetingCount: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingSubjectType?: MeetingSubjectTypes;
  }): Observable<Array<MeetingOccurrenceModel>> {
    return this.apiSchedulingSiteParentSiteKeyMeetingCountGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MeetingOccurrenceModel>>) => r.body as Array<MeetingOccurrenceModel>)
    );
  }

  static readonly ApiSchedulingSiteParentSiteKeyAvailableDatesGetPath = '/api/Scheduling/site/{parentSiteKey}/availableDates';

  apiSchedulingSiteParentSiteKeyAvailableDatesGet$Json$Response(params: {
    parentSiteKey: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingSubjectType?: MeetingSubjectTypes;
  }): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, SchedulingService.ApiSchedulingSiteParentSiteKeyAvailableDatesGetPath, 'get');
    if (params) {
      rb.path('parentSiteKey', params.parentSiteKey, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('meetingSubjectType', params.meetingSubjectType, {});
    }
    return this.http.request(rb.build({ responseType: 'json', accept: 'text/json' })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Array<string>>)
    );
  }

  apiSchedulingSiteParentSiteKeyAvailableDatesGet$Json(params: {
    parentSiteKey: number;
    fromDate?: null | string;
    toDate?: null | string;
    meetingSubjectType?: MeetingSubjectTypes;
  }): Observable<Array<string>> {
    return this.apiSchedulingSiteParentSiteKeyAvailableDatesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}
